<template>

  <van-tabbar v-model="active">
    <van-tabbar-item to="/home" @click="changeTabItem(0)" >
      <span>首页</span>
      <img
        slot="icon"
        slot-scope="props"
        src="@/images/icon_home@3x.png"
      >
    </van-tabbar-item>
    <van-tabbar-item icon="search" :info="cartInfo.cartNum == 0? '':cartInfo.cartNum" @click="changeTabItem(1)" >
      <span>购物车</span>
      <img
        slot="icon"
        slot-scope="props"
        src="@/images/icon_shopping cart@3x.png"
      >
    </van-tabbar-item>
    <van-tabbar-item icon="friends-o" dot @click="changeTabItem(2)">
      <span>我的订单</span>
      <img
        slot="icon"
        slot-scope="props"
        src="@/images/icon_Order@3x.png"
      >
    </van-tabbar-item>
    <van-tabbar-item icon="friends-o" dot @click="goMine()">
      <span>会员中心</span>
      <img
        slot="icon"
        slot-scope="props"
        src="@/images/Product_Icon_MemberCenter_Inactive@3x.png"
      >
    </van-tabbar-item>
  </van-tabbar>

</template>
<script>
  import { Tabbar, TabbarItem,Toast,Dialog } from 'vant'
  import { storeName,prodCatalogId,} from '@/router/Constant'
  import { getShoppingCartNum,login } from '@/router/api';
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import {loginInfo} from "@/router/Constant";
  export default {
    name: 'FooterTabbar',
    props: ['cartInfo'],
    components: {
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
      [Toast.name]: Toast,
      [Dialog.name]: Dialog
    },
    data() {
      return {
        active: 'home',
        token:"",
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        catNum:0,
      }
    },
    mounted(){
      // this.initData();
      console.log(this.active)
    },
    methods:{
      async initData() {
        this.getShoppingCartNum();
      },
      getShoppingCartNum() {
        getShoppingCartNum({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
          .then(res => {
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              this.catNum = res.catNum;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      login (){
        login({USERNAME:loginInfo.userName,PASSWORD:loginInfo.password})
          .then(res => {
            console.log(res)
            if (res._TOKEN_){
              setStore('externalLoginKey',res._TOKEN_)
              setStore('islogIn',true)
              Toast("用户已经模拟登录")
              this.getShoppingCartNum();
            } else {
              Toast("用户未登录")
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      changeTabItem(active) {
        switch (active) {
          case 0:
            this.$router.push({name:'home'});
          break;
          case 1:
            var isLogIn = getStore('islogIn');
            if (isLogIn == 'false') {
              this.dialogAction('购物车需要登录，是否现在登录？');
            } else {
              this.$router.push({name:'cart'});
            }
            break;
          case 2:
            var isLogIn = getStore('islogIn');
            if (isLogIn == 'false') {
              this.dialogAction('查看订单需要登录，是否现在登录？');
            } else {
              this.$router.push({name:'orderList'});
            }
            break;
          default:
              break;
        }
      },

      //跳转至小程序个人中心
      goMine:function(){
        wx.miniProgram.switchTab({url:'../../pages/mine/mine'})
      },

      dialogAction(msg){
        Dialog.confirm({
          message: msg
        }).then(() => {
          if (getStore('fromType')=='mini') {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          } else {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          }
        }).catch(() => {

        });
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/page/common/footer.vue